import { BaseModel } from './BaseModel';
import Meeting from './Meeting';
import Vimeo from './Vimeo';

export class MeetingRecord extends BaseModel {
  static get entity() {
    return 'meeting_records';
  }

  static get fk() {
    return 'meeting_record_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      vimeo_id: this.attr(null),
      vimeo: this.belongsTo(Vimeo, 'vimeo_id'),
      meeting_id: this.attr(null),
      meeting: this.belongsTo(Meeting, 'meeting_id'),
      chat: this.attr(null),
      is_listed: this.boolean(false),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      created_by: this.attr(null),
      updated_by: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetchById(id) {
        return this.get(`/meeting-records/${id}`);
      },

      update(id, body) {
        return this.put(`/meeting-records/${id}`, body);
      }
    }
  };
}

export default MeetingRecord;
